import { Outlet } from "react-router-dom";
import { Header } from "@/components/public/Header";
import { Footer } from "@/components/public/Footer";
import { Toaster } from "@/components/ui/sonner";

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-mtm-bg">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
